/**
 * Icons.ts
 * Backward-compatible barrel re-exporting UI_ICONS and the modular SVG icon suite.
 * Engineered with crisp inline SVG vector art, rounded caps/joins, and zero external dependencies.
 */

import { UI_SYSTEM_SVG_ICONS } from './icons/UiSystemIcons';
import { renderUiGouacheIcon, UiGouacheIconKey } from './icons/IconRenderer';

export const UI_ICONS = {
  ...UI_SYSTEM_SVG_ICONS,
} as const;

export function getMoodIconSvg(val: number): string {
  if (val > 70) return UI_ICONS.heartSmile;
  if (val >= 40) return UI_ICONS.moodContent;
  if (val > 15) return UI_ICONS.moodLow;
  return UI_ICONS.moodDepressed;
}

export function getMoodGouacheIconHtml(val: number, size: number = 19): string {
  const safeVal = typeof val === 'number' && Number.isFinite(val) ? val : 0;
  const isHappyOrContent = safeVal >= 40;
  const key: UiGouacheIconKey = isHappyOrContent ? 'icon_mood_happy' : 'icon_mood_low';
  const stateModifier =
    safeVal <= 15
      ? 'ui-gouache-mood--critical'
      : safeVal < 40
        ? 'ui-gouache-mood--tired'
        : safeVal <= 70
          ? 'ui-gouache-mood--calm'
          : 'ui-gouache-mood--joyful';
  return renderUiGouacheIcon(key, {
    size,
    className: `hud-gouache-stat-img ${stateModifier}`,
  });
}

export function getTimeOfDayBadgeInfo(hour: number = new Date().getHours()): {
  iconSvg: string;
  iconHtml: string;
  iconKey: UiGouacheIconKey;
  label: string;
  phaseClass: string;
} {
  const safeHour =
    typeof hour === 'number' && Number.isFinite(hour)
      ? ((Math.floor(hour) % 24) + 24) % 24
      : 12;
  if (safeHour >= 17 && safeHour < 20) {
    return {
      iconSvg: UI_ICONS.sunset,
      iconHtml: renderUiGouacheIcon('icon_time_sunset', {
        size: 19,
        className: 'hud-gouache-tod-img',
      }),
      iconKey: 'icon_time_sunset',
      label: 'Hoàng hôn',
      phaseClass: 'tod-sunset',
    };
  }
  if (safeHour >= 20 || safeHour < 6) {
    return {
      iconSvg: UI_ICONS.moon,
      iconHtml: renderUiGouacheIcon('icon_time_night', {
        size: 19,
        className: 'hud-gouache-tod-img',
      }),
      iconKey: 'icon_time_night',
      label: 'Ban đêm',
      phaseClass: 'tod-night',
    };
  }
  return {
    iconSvg: UI_ICONS.sun,
    iconHtml: renderUiGouacheIcon('icon_time_day', {
      size: 19,
      className: 'hud-gouache-tod-img',
    }),
    iconKey: 'icon_time_day',
    label: 'Ban ngày',
    phaseClass: 'tod-day',
  };
}

// Re-export modular icon system
export * from './icons/index';
